import { Item } from "./index";
import { ResponseData } from "./tunnel-message-data";

/**
 * @hidden
 */
export interface CreateItemResponse extends ResponseData {
    type: '@stemcstudio/gradebook:create-item-response';
    value?: Item;
}

/**
 * @hidden
 */
export function isCreateItemResponse(message: MessageEvent): message is MessageEvent<CreateItemResponse> {
    const duck = message as MessageEvent<CreateItemResponse>;
    if (duck.data.type && duck.data.type === '@stemcstudio/gradebook:create-item-response') {
        return true;
    } else {
        return false;
    }
}

